import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ModalBody, ModalFooter } from '@vds/modals';
import { RadioButtonGroup } from '@vds/radio-buttons';
import { TitleLockup } from '@vds/type-lockups';

import { useDispatch } from 'react-redux';
import { is5G, isLTE, isMVA, isMobile } from '../../../common/Helpers';
import { VDSModal as Modal } from '../../../common/Modal/VDSModal';

import { multipleSessionsLabels } from './MultipleSessionsLabels';
import { Margin } from '../../../common/styles';
import { eventDispatcher } from '../../../common/Tagging';

const MultipleSessionsModal = (props) => {
  const [selectedOption, setSelectedOption] = useState('continue');
  const { multiSessionTitle, continueOption, exitOptionMobile, exitOptionDesktop } = multipleSessionsLabels || {};
  const exitText = isMVA() || isMobile() ? exitOptionMobile : exitOptionDesktop;
  const dispatch = useDispatch();

 
  useEffect(() => {
    if (props.isOpen) {
      const pageLoadObj = {
        name: multiSessionTitle,
        selector: 'MultipleSessionsModal',
      };
      eventDispatcher('openView', pageLoadObj);
      const linkCallObj = {
        name: continueOption,
        data: {
          page: {
            detail: multiSessionTitle,
          },
        },
      };
      eventDispatcher('linkClick', linkCallObj);
    }
  }, [props.isOpen]);

  const handleOpenChange = (val) => {
    if (!val) {
      props.change();
    }
  };

  const handleContinue = () => {
    if (selectedOption === 'exit') {
      dispatch({ type: 'HIDE_DEVICELOCK_MODAL' });
      if (is5G) {
        window.location.href = '/home/internet/5g/';
      } else if (isLTE) {
        window.location.href = '/home/internet/lte/';
      }
    } else if (selectedOption === 'continue') {
      dispatch({ type: 'HIDE_DEVICELOCK_MODAL' });
      window.location.href = `${window.location.origin}/sales/home/expresscart.html?expresscart=true&resumecart=true`;
    }
  };

  return (
    <Modal ariaLabel="Multiple Sessions Modal" opened={props.isOpen} onOpenedChange={handleOpenChange} closeButton={null} disableOutsideClick>
      <ModalBody>
        <Margin bottom="20px">
          <TitleLockup
            data={{
              title: {
                bold: false,
                size: 'titleMedium',
                children: multiSessionTitle,
              },
            }}
          />
        </Margin>

        <RadioButtonGroup
          onChange={(e) => setSelectedOption(e.target.value)}
          error={false}
          value={selectedOption}
          id="devicelockradio"
          data={[
            {
              name: 'group',
              children: continueOption,
              value: 'continue',
              ariaLabel: 'continue',
              disabled: false,
              'data-track':`'{"type":"link","name":"${continueOption}","data":{"page":{"detail":"${multiSessionTitle}"}}}'`,
             },
            {
              name: 'group',
              children: exitText,
              value: 'exit',
              ariaLabel: 'exit',
              'data-track':`'{"type":"link","name":"${exitText}","data":{"page":{"detail":"${multiSessionTitle}"}}}'`,
            },
          ]}
        />
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: '100%',
            children: 'Continue',
            'data-track':`'{"type":"link","name":"continue","data":{"page":{"detail":"${multiSessionTitle}"}}}'`,
            onClick: () => handleContinue(),
          }, 
        }}
      />
    </Modal>
  );
};

MultipleSessionsModal.propTypes = {
  isOpen: PropTypes.bool,
  change: PropTypes.func,
};

export default MultipleSessionsModal;
